module.exports = __webpack_public_path__ + "static/media/insta-checkmark.4e5880b3.svg";